import { Pipe, PipeTransform } from '@angular/core';
import {CurrencyService} from 'src/app/services/currency.service';

@Pipe({
    name: 'sysLocation',
    standalone: false
})
export class CustomLocationPipe implements PipeTransform {

  constructor(
      private sys: CurrencyService
  ) {}

  transform(value: string): string {
    return this.sys.getLocation(value) ? this.sys.getLocation(value).locationName : '';
  }

}
